import { AvatarGroup, Avatar, Tooltip } from '@mui/material';
import { brandInitials } from '../../lib/format';
import { avatarColor } from './avatarColor';

function CollaboratorAvatarGroup({ collaborators, max = 4, size = 36 }) {
  return (
    <AvatarGroup max={max} sx={{ width: 'fit-content', '& .MuiAvatar-root': { width: size, height: size, fontSize: size * 0.38 } }}>
      {collaborators.map((person) => (
        <Tooltip key={person.name} title={person.role ? `${person.name} · ${person.role}` : person.name}>
          <Avatar src={person.avatarUrl} sx={{ bgcolor: avatarColor(person.name) }}>
            {brandInitials(person.name)}
          </Avatar>
        </Tooltip>
      ))}
    </AvatarGroup>
  );
}

export default CollaboratorAvatarGroup;
